import React, { useContext } from 'react';
import 'twin.macro';
import Page, { PageContext } from '@leuven2030/framework/Page/Page';
import ContentPrismic from '@leuven2030/framework/Content/ContentPrismic';
import NewsArticleCover from '@leuven2030/food/News/NewsArticleCover';
import ContentVideo from '@leuven2030/framework/Content/ContentVideo';
import ContentQuote, {
  ContentQuoteQuery
} from '@leuven2030/framework/Content/ContentQuote';
import { StyleContent } from '@leuven2030/food/styles/general';
import NewsRecommendations from '@leuven2030/food/News/NewsRecommendations';
import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';
import PagePaths from '@leuven2030/food/Page/PagePaths';
import PageProps from '@leuven2030/food/Page/PageProps';
import { useRouter } from 'next/router';
import PageFallback from '@leuven2030/food/Page/PageFallback';
import Page404 from '@leuven2030/food/Page/Page404';
import NewsArticleFooter from '@leuven2030/food/News/NewsArticleFooter';
import ContentSource from '@leuven2030/framework/Content/ContentSource';
import get from 'lodash/get';
import { NewsPageQueryContent } from '@leuven2030/framework/News/NewsPageQuery';
import { gql } from '@apollo/client';
import Moment from 'react-moment';

const NewsArticlePage = Page(() => {
  const {
    prismic: { news_article }
  } = useContext(PageContext);

  const router = useRouter();

  if (router.isFallback) {
    return <PageFallback />;
  }

  if (!news_article) {
    return <Page404 />;
  }

  const {
    body,
    event_date_start,
    event_link,
    group,
    event_date_end,
    event_place,
    event_address,
    event_include_time
  } = news_article;
  console.log(event_link);
  return (
    <>
      <PageLayoutDefault tw=" flex flex-col bg-gray-50 bg-gray-50">
        <NewsArticleCover />
        <div tw="divide-y" css={StyleContent}>
          <div tw="py-6 flex justify-between items-stretch space-x-6">
            <div>
              <h1 tw="text-4xl text-gray-800">{news_article.title}</h1>
              <ContentSource
                url={get(news_article.source, 'url') || event_link}
                tw="text-primary-600 mt-4"
              />
            </div>
            {group._meta.uid === 'event' && (
              <div tw="bg-gray-100 p-3 space-y-3" css={{ minWidth: 100 }}>
                <div>
                  <h3 tw="font-bold text-gray-600">Locatie</h3>
                  <p tw="text-gray-500">{event_place}</p>
                  <p tw="text-gray-500">{event_address}</p>
                </div>
                {event_include_time && (
                  <div>
                    <h3 tw="font-bold text-gray-600">Tijd</h3>
                    <div tw="text-primary-600">
                      <Moment format="HH:mm">{event_date_start}</Moment>
                      {event_date_end && (
                        <>
                          <span>-</span>
                          <Moment format="HH:mm">{event_date_end}</Moment>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <ContentPrismic
            tw="py-6"
            slices={body}
            SliceComponents={[ContentVideo, ContentQuote]}
          />
          <NewsArticleFooter tw="py-6" />
        </div>
        <NewsRecommendations />
      </PageLayoutDefault>
    </>
  );
});

const UiSchoolNewsArticlePage = (props) => <NewsArticlePage {...props} />;
export const getStaticProps = PageProps({
  prismic: {
    query: gql`
      query getService($uid: String!) {
        news_article(uid: $uid, lang: "nl-be") {
          title
          group{
            ... on Update_group{
              title
              color
              show_all_label
              icon{
                ... on _ImageLink {
                  url
                }
              }
              _meta{
                type
                uid
              }
            }
          }
          cover{
            ... on _ImageLink {
              url
            }
          }
          _meta{
            uid
          }
          source{
            ... on _ExternalLink{
              url
            }
          }
          description
          published_date
          body {
            ... on News_articleBodyRich_text {
              type
              primary {
                text
              }
            }
            ${ContentQuoteQuery({ typeName: 'News_article' })}
            ... on News_articleBodyEmbed {
              type
              primary {
                embed_title
                embed_url
              }
            }
          }
          event_date_start
          event_link
          event_include_time
          event_date_end
          event_place
          event_address
          event_location
        }
        ${NewsPageQueryContent}
      }
    `,
    onContext: ({ params }, options) => {
      const { uid } = params || {};
      options.setVariables({
        uid
      });
    }
  }
});

export const getStaticPaths = PagePaths({
  type: 'news_article'
});

export default UiSchoolNewsArticlePage;
